import {ElementEventType} from '@gl/lit/common/constants/index.js';
import type {IImmutableComponent} from '@gl/lit/components/mixins/immutable_component/index.js';
import type {VariantAtom} from '@gl/lit/types/architecture.js';

/**
 * Immutable cmd for dispatching an element's change event.
 */
export function change<
  Model,
  Msg extends VariantAtom<string>,
  T extends IImmutableComponent<Model, Msg> | Element,
>(element: T) {
  element.dispatchEvent(new Event(ElementEventType.Change));
}
